import { SWITCH, TEXT, SELECT, COUNTER } from "../../components/Common/Const";

export const WhiteLabelField = [
  {
    name: "domain",
    label: "Domain",
    isRequired: true,
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "imagePath",
    label: "Image",
    type: TEXT,
    accept: "image/*",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },

  // reCAPTCH Settings
  {
    type: SWITCH,
    name: "isRecatchEnable",
    label: "Enable reCATCH",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "recatchKey",
    label: "reCATCH Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isRecatchEnable",
    dependsOnValue: true,  },

  // Google Login Settings
  {
    type: SWITCH,
    name: "isGoogleLogin",
    label: "Enable Google Login",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "googleKey",
    label: "Google Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isGoogleLogin",
    dependsOnValue: true,
  },

  // Facebook Login Settings
  {
    type: SWITCH,
    name: "isFacebookLogin",
    label: "Enable Facebook Login",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "facebookKey",
    label: "Facebook Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isFacebookLogin",
    dependsOnValue: true,
  },
  {
    name: "mobileGoogleFirebaseKey",
    label: "Mobile Firebase Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "mobileGoogleFirebaseUrl",
    label: "Mobile Firebase URL",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "clientOTP",
    label: "Client OTP",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isActive",
    label: "Active",
    defaultValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isDemoClientLogin",
    label: "Demo Android",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isDemoClientEnableInIOS",
    label: "Demo IOS",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },

  {
    type: SWITCH,
    name: "isSendMobileOTP",
    label: "Enable Mobile OTP",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isSendMailOTP",
    label: "Enable Mail OTP",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "sendMailType",
    label: "Mail Type",
    type: SELECT,
    options: [
      { label: "Select Mail Type", value: "0" },
      { label: "Gmail", value: 1 },
      { label: "SMTP", value: 2 },
    ],
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMailOTP",
    dependsOnValue: true,
  },
  {
    name: "sendMailMaxSendLimit",
    label: "Mail Max Send Limit",
    type: COUNTER,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMailOTP",
    dependsOnValue: true,
  },
  {
    name: "sendMobileOTPType",
    label: "Mobile OTP Type",
    type: SELECT,
    options: [
      { label: "Select Mobile OTP Type", value: "0" },
      { label: "OTP Login", value: 1 },
      { label: "OTPless SDK", value: 2 },
    ],
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "sendMobileOTPMaxSendLimit",
    label: "Mobile OTP Max Send Limit",
    type: COUNTER,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPAuthKey",
    label: "Mobile OTP Auth Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPExpired",
    label: "Mobile OTP Expiry (minutes)",
    type: COUNTER,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileSemlessOTPKey",
    label: "Mobile Seamless OTP Key",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPSendUrl",
    label: "Mobile OTP Send URL",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPResendUrl",
    label: "Mobile OTP Resend URL",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPForgotUrl",
    label: "Mobile OTP Forgot URL",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    name: "mobileOTPVerify",
    label: "Mobile OTP Verification URL",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    dependsOnField: "isSendMobileOTP",
    dependsOnValue: true,
  },
  {
    type: SWITCH,
    name: "isAppVersionForceUpdate",
    label: "App Version Force Update",
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  }
];
